(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // 12-10-2026 (Bas, derde poging, met Fable): de menubalk knipperde op de iPhone.
  // Wat er anders is dan in de oude Dawn-logica:
  // 1. De kop staat ALTIJD vast (position: sticky). Er wordt nooit meer tijdens het
  //    scrollen tussen static en sticky gewisseld; dat wisselen dwong Safari elke
  //    keer tot een nieuwe tekenlaag en een nieuwe plakpositie, en juist op dat
  //    moment tekende hij de balk een beeldje op de oude plek.
  // 2. Verbergen en tonen gaat alleen met een transform, met een vaste overgang,
  //    en hoogstens een keer per beeldje (requestAnimationFrame), nooit per
  //    scroll-event. iOS levert scroll-events laat en soms met een verouderde
  //    positie; per beeldje beoordelen haalt die ruis eruit.
  // 3. Geen will-change, geen translateZ, geen backface-visibility meer (de fix
  //    van 09-10): die hielden een eigen laag met een permanente transform in
  //    stand, waardoor de vaste balk ook nog eens de ankerbox werd van de
  //    menulade en het zoekvenster.
  // 4. Een verandering van de vensterhoogte (de adresbalk van iOS die in- of
  //    uitklapt) telt niet als scrollbeweging. Elastisch doorscrollen boven of
  //    onder de pagina ook niet.
  // 5. Bovenin de pagina, zolang de kop en wat erboven staat nog in beeld kunnen
  //    zijn, wordt de kop nooit verborgen. Daarbuiten pas na 40 px in dezelfde
  //    richting en nooit vaker dan eens per 250 ms.
  // Stand "always" (altijd vast): geen scroll-logica, de kop blijft gewoon staan.
  // Testschakelaar voor de telefoon: ?kop=vast of ?kop=verberg (blijft voor de
  // rest van de sessie staan; ?kop=uit wist hem).
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      let modus = this.getAttribute('data-sticky-type');
      try {
        const p = new URLSearchParams(window.location.search).get('kop');
        if (p === 'uit') window.sessionStorage.removeItem('dpk_kop');
        else if (p) window.sessionStorage.setItem('dpk_kop', p);
        const s = window.sessionStorage.getItem('dpk_kop');
        if (s === 'vast') modus = 'always';
        else if (s === 'verberg') modus = 'on-scroll-up';
      } catch (e) {}
      this.modus = modus;
      this.headerIsAlwaysSticky = modus === 'always' || modus === 'reduce-logo-size';

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // In beide standen staat de kop vast; alleen de zichtbaarheid verschilt.
      this.header.classList.add('shopify-section-header-sticky');

      this.preventReveal = false;
      this.preventHide = false;
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Altijd vast: een sprong naar een anker (bijvoorbeeld naar de reviews)
      // eindigt dan niet onder de kop (zie theme.css, html.dpk-kop-vast).
      document.documentElement.classList.toggle('dpk-kop-vast', this.headerIsAlwaysSticky);
      if (this.headerIsAlwaysSticky) return;

      this.predictiveSearch = this.querySelector('predictive-search');
      this.laatsteY = Math.max(0, window.scrollY || 0);
      this.laatsteHoogte = window.innerHeight;
      this.richting = 0;
      this.richtingStart = this.laatsteY;
      this.laatsteWissel = 0;
      this.ingepland = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.beoordeelHandler = this.beoordeel.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.ingepland) return;
      this.ingepland = true;
      window.requestAnimationFrame(this.beoordeelHandler);
    }

    // Waar de bovenkant van de kop zou staan als er niets vast zat: de onderkant
    // van het laatste gewone element erboven (de mededelingsbalk), in paginamaten.
    natuurlijkeTop(y) {
      let el = this.header.previousElementSibling;
      while (el) {
        const cs = window.getComputedStyle(el);
        if (cs.display !== 'none' && cs.position !== 'fixed' && cs.position !== 'absolute' && el.offsetHeight > 0) {
          return el.getBoundingClientRect().bottom + y;
        }
        el = el.previousElementSibling;
      }
      return 0;
    }

    beoordeel() {
      this.ingepland = false;
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const hoogte = window.innerHeight;
      const max = document.documentElement.scrollHeight - hoogte;

      if (hoogte !== this.laatsteHoogte) {
        this.laatsteHoogte = hoogte;
        this.laatsteY = y;
        this.richtingStart = y;
        return;
      }
      if (y < 0 || y > max) {
        this.laatsteY = Math.min(Math.max(y, 0), Math.max(max, 0));
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (y <= this.natuurlijkeTop(y) + this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        this.toon();
        this.laatsteY = y;
        this.richting = 0;
        this.richtingStart = y;
        return;
      }
      if (!this.header.classList.contains('scrolled-past-header')) this.header.classList.add('scrolled-past-header');

      const delta = y - this.laatsteY;
      this.laatsteY = y;
      const richting = delta > 0 ? 1 : (delta < 0 ? -1 : 0);
      if (richting === 0) return;
      if (richting !== this.richting) {
        this.richting = richting;
        this.richtingStart = y - delta;
      }
      if (Math.abs(y - this.richtingStart) < 40) return;
      const nu = window.performance.now();
      if (nu - this.laatsteWissel < 250) return;

      if (richting === 1) {
        if (this.preventHide) return;
        if (this.verberg()) this.laatsteWissel = nu;
      } else if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this.verberg();
      } else if (this.toon()) {
        this.laatsteWissel = nu;
      }
    }

    verberg() {
      if (this.headerIsAlwaysSticky) return false;
      if (this.header.classList.contains('shopify-section-header-hidden')) return false;
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      return true;
    }

    toon() {
      if (!this.header.classList.contains('shopify-section-header-hidden')) return false;
      this.header.classList.remove('shopify-section-header-hidden');
      return true;
    }

    hide() { this.verberg(); }
    reveal() { this.toon(); }
    reset() { this.toon(); }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
